import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import React from "react"

const FooterListItem = ({ displayText }, icon, lang) => {
    const text = displayText.filter(x => x.lang === lang)[0].text

    return (
        <ListItem style={{ padding: 0 }}>
            <ListItemText style={{ flexGrow: 0 }}>{text}</ListItemText>
            {icon ? <ListItemIcon style={{ minWidth: "auto", paddingLeft: text !== "" ? 10 : 0 }}>{icon}</ListItemIcon> : null}
        </ListItem>
    )
}

export default FooterListItem
